import { Component, EventEmitter, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'multisite-locked-content-mask-type-two',
  templateUrl: './locked-content-mask-type-two.component.html',
  styleUrls: ['./locked-content-mask-type-two.component.scss'],
  imports: [
    TranslocoModule
  ],

})
export class LockedContentMaskTypeTwoComponent {

  titleText = input<string | undefined>(undefined);
  titleTranslationKey = input<string | undefined>(undefined); // 'common.instructions'
  descriptionText = input<string | undefined>(undefined);
  descriptionTranslationKey = input<string | undefined>(undefined); // 'common.instructions'
  iconClasses = input<string | undefined>(undefined); // 'fa fa-heart'
  cta_text = input<string | undefined>(undefined); // 'Go to Tip' 
  cta_translationKey = input<string | undefined>(undefined); // 'content.go'
  ctaButtonClasses = input<string | undefined>('btn btn-sm btn-success');
  smallButton = input<boolean | undefined>(true); // TODO make this a dynamic input in future when needed

  lockLinkClicked = output<void>();


  doLockLinkClick (){
    this.lockLinkClicked.emit();
  }

}
